import * as i0 from "@angular/core";
export class SignupStore {
}
SignupStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SignupStore_Factory() { return new SignupStore(); }, token: SignupStore, providedIn: "root" });
export var SignupStoreKeys;
(function (SignupStoreKeys) {
})(SignupStoreKeys || (SignupStoreKeys = {}));
